import Button from './Button';

const Pagination = ({ activePage, count, rowsPerPage, totalPages, setActivePage }) => {
	const firstPage = activePage === 1 ? 1 : rowsPerPage * (activePage - 1) + 1;
	const lastPage = activePage === totalPages ? count : firstPage + rowsPerPage - 1;

	return (
		<>
			<div className='pagination'>
				<div className='pagination__left'>
					<Button type='pagination' title='Click to view first page' disabled={activePage === 1} onClick={() => setActivePage(1)}>
						First Page
					</Button>
					<Button type='pagination' title='Click to view previous page' disabled={activePage === 1} onClick={() => setActivePage(activePage - 1)}>
						Previous Page
					</Button>
				</div>
				<div className='pagination__center'>
					<p>
						Page: {activePage} of {totalPages}
					</p>
					<p>
						Rows: {firstPage === lastPage ? lastPage : `${firstPage} - ${lastPage}`} of {count}
					</p>
				</div>
				<div className='pagination__right'>
					<Button type='pagination' title='Click to view next page' disabled={activePage === totalPages} onClick={() => setActivePage(activePage + 1)}>
						Next Page
					</Button>
					<Button type='pagination' title='Click to view last page' disabled={activePage === totalPages} onClick={() => setActivePage(totalPages)}>
						Last Page
					</Button>
				</div>
			</div>
		</>
	);
};

export default Pagination;
